import { useStyles } from '@webapps/styles';
import { ArrowForwardRounded } from '@material-ui/icons';

const InformationAddBusiness = ({ opcoRecord, handleClick }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);



  return (
    <div className={cx(global.fcjc, classes.information)} onClick={handleClick}>
      <div className={global.frac} style={{ gap: 8 }}>
        <div className={classes.contractSpan}>AJOUTER L'ENTREPRISE</div>
        <h1 className={global.title} style={{ margin: 0 }}>Ajouter l'entreprise</h1>
        <ArrowForwardRounded style={{ color: "#0060F9", fontSize: 12 }} />
      </div>
      <div className={classes.kawaiiText}>Synchroniser votre dossier auprès de l'OPCO pour y assurer son suivi</div>
    </div>
  );
};

const styles = ({ fontSizes, spacing }) => ({
  information: {
    backgroundColor: "#C0D9FF",
    cursor: "pointer",
    gap: 8,
    padding: 20,
    borderRadius: 10,
    "&:hover h1": {
      color: "#0060F9",
    },
  },
  contractSpan: {
    backgroundColor: "#0060F9",
    borderRadius: '5px',
    padding: '0px 5px',
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontSize: '12px',
    color: "white"
  },
  kawaiiText: {
    fontSize: 12,
  }
});

export default InformationAddBusiness;